const apiUrl = process.env.REACT_APP_API_URL;

export const GetClassesEscola = async (
    page: string,
    escola: string,
    inici: string,
    fin: string
): Promise<any[]> => {
    try {
        const response = await fetch(
            `${apiUrl}:8072/escoles/classes?escola=${encodeURIComponent(escola)}&inici=${inici}&fin=${fin}`,
            {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'pantalla': page
                }
            }
        );
        if (!response.ok) {
            console.error('GetClassesEscola error:', response.status);
            return [];
        }
        const jsonData = await response.json();
        return Array.isArray(jsonData) ? jsonData : [];
    } catch (error) {
        console.log('GetClassesEscola fetch error:', error);
        return [];
    }
};
